export default "__VITE_ASSET__a3b6ded6__"